<template>
  <span>
    <b-form-select
      v-model="action.gridId"
      :options="availableGrids"
      size="sm"
      @change="gridSelected"
    />

    <div v-if="action.gridId">
      <div v-for="(writeMethod, idx) in action.writeMethods" :key="idx">
        <span>Then set value from</span>
        <b-form-select
          v-model="writeMethod.type"
          :options="valueSourceTypes"
          size="sm"
          @change="writeMethodSelected($event, idx)"
        />

        <SetValueFromRow
          v-if="writeMethod.type === 'createdRow'"
          :eventBus="eventBus"
          :writeMethod="writeMethod"
          :writeMethodIdx="idx"
          :action="action"
          :actionIdx="actionIdx"
          :sourceGrid="sourceGrid"
        />

        <SetValueFromExpression
          v-if="writeMethod.type === 'expression'"
          :eventBus="eventBus"
          :writeMethod="writeMethod"
          :writeMethodIdx="idx"
          :action="action"
          :actionIdx="actionIdx"
          msg="to added row cell"
          :gridId="action.gridId"
        />

        <a href="#" @click.prevent="removeWriteMethod(idx)">
          <icon name="remove" />
        </a>
      </div>

      <b-button variant="success" size="sm" @click="addWriteMethod">
        <span v-if="action.writeMethods.length > 0">And</span>
        <span v-else>Do</span>
      </b-button>
    </div>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'
// components
import SetValueFromRow from '../../../actions/SetValueFromRow'
import SetValueFromExpression from '../../../actions/SetValueFromExpression'

export default {
  props: ['eventBus', 'action', 'actionIdx', 'sourceGrid'],
  components: {
    SetValueFromRow,
    SetValueFromExpression,
  },
  data() {
    return {
      valueSourceTypes: [
        { text: 'Newly created row cell', value: 'createdRow' },
        { text: 'Expression', value: 'expression' },
      ],
    }
  },
  computed: {
    ...mapGetters(['dataGrid_select']),
    availableGrids() {
      const availableGrids = []
      const allGrids = this.dataGrid_select.slice()

      for (let grid of allGrids) {
        if (grid.value === this.sourceGrid) continue

        availableGrids.push(grid)
      }

      return availableGrids
    },
  },
  methods: {
    gridSelected(gridId) {
      const action = {
        type: this.action.type,
        gridId,
      }

      if (!action.writeMethods) action.writeMethods = [{}]

      this.eventBus.$emit('setAction', action, this.actionIdx)
    },
    updateAction() {
      this.eventBus.$emit(
        'setAction',
        Object.assign({}, this.action),
        this.actionIdx
      )
    },
    writeMethodSelected(type, idx) {
      this.action.writeMethods[idx] = { type }

      this.updateAction()
    },
    addWriteMethod() {
      this.action.writeMethods.push({})

      this.updateAction()
    },
    removeWriteMethod(idx) {
      this.action.writeMethods.splice(idx, 1)

      this.updateAction()
    },
  },
}
</script>
